import { Button } from '@mui/material';
import React, { useState } from 'react';
import DefaultDialog from '../DefaultDialog';
import DropdownButtonItem from '../DropdownButtonItem';

interface Props {
	label: string;
	message: string;
	confirmText: string;
	cancelText?: string;
	dropdownItem?: boolean;
	onConfirm: () => void;
	children?: React.ReactNode;
}

const ActionConfirmationTrigger = (props: Props) => {
	const { label, message, confirmText, dropdownItem, onConfirm, cancelText } =
		props;

	const [isOpen, setIsOpen] = useState(false);
	const close = () => setIsOpen(false);
	const open = () => setIsOpen(true);
	const onConfirmClick = () => {
		close();
		onConfirm();
	};

	return (
		<>
			{dropdownItem ? (
				<DropdownButtonItem onClick={open} label={label} />
			) : (
				<Button
					id={
						label?.toLowerCase().split(' ').join('-') +
						'--action-confirmation-trigger'
					}
					variant='contained'
					onClick={open}
				>
					{label}
				</Button>
			)}
			<DefaultDialog
				actions={[
					{ text: confirmText, onClick: onConfirmClick },
					{ text: cancelText || 'Cancel', onClick: close },
				]}
				open={isOpen}
				onClose={close}
				title={message}
			>
				{props.children}
			</DefaultDialog>
		</>
	);
};

export default ActionConfirmationTrigger;
